export function splitOpenHoursForDisplay(openHours, fallback = 'Hours vary') {
  const text = String(openHours || '').trim();
  if (!text) {
    return [{ day: null, hours: fallback }];
  }

  const weekdayPattern = '(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)';
  const weekdayBoundary = new RegExp(`\\s*[,;]?\\s*(?=${weekdayPattern}\\s*:)`, 'gi');
  const parts = text
    .replace(weekdayBoundary, '\n')
    .split(/\n+/)
    .map(part => part.trim())
    .filter(Boolean);

  return parts.map(part => {
    const separatorIndex = part.indexOf(':');
    if (separatorIndex <= 0) {
      return { day: null, hours: part };
    }

    const day = part.slice(0, separatorIndex).trim();
    const hours = part.slice(separatorIndex + 1).trim();
    return {
      day: day || null,
      hours: hours || fallback,
    };
  });
}
